import React, { ReactNode } from 'react';
import { Col, Row, Form } from 'antd';
import { Card, CurrencyInput, Gutter, Icon, Text } from '@common/components';
import clsx from 'clsx';

export type EmploymentTypeType = 'traveler' | 'local' | 'directSourcing';

export function RatesLongTermStepFormEmploymentTypeFields({
  type,
  onBlur,
}: {
  type: EmploymentTypeType;
  onBlur?: (name: string) => void;
}) {
  const className = `${type.replace('S', '-s')}-employment-type`;

  return (
    <div
      className={clsx('rates-long-term-by-employment-type', className)}
      style={{ width: '278px' }}
    >
      <Card>
        <Gutter direction="bottom" size="md">
          <Text align="left" transform="capitalize">
            {type.replace('directSourcing', 'Direct Sourcing')}
          </Text>
        </Gutter>
        <Row>
          <RateField
            label="Day"
            name={`${type}DayRate`}
            icon={<Icon icon="sun" color="sunDarker" />}
            onBlur={onBlur}
          />
          <RateField
            label="Evening"
            name={`${type}EveningRate`}
            icon={<Icon icon="sunset" color="harvestGold" />}
            onBlur={onBlur}
          />
          <RateField
            label="Night"
            name={`${type}NightRate`}
            icon={<Icon icon="moon" color="skyDarker" />}
            onBlur={onBlur}
          />
          <RateField
            label="Variable"
            name={`${type}VariableRate`}
            icon={<Icon icon="shuffle" color="harvestGold" />}
            onBlur={onBlur}
          />
        </Row>
      </Card>
    </div>
  );
}

function RateField({
  name,
  label,
  icon,
  onBlur,
}: {
  name: string;
  label: string;
  icon: ReactNode;
  onBlur?: (name: string) => void;
}) {
  return (
    <>
      <Col span={8}>
        <Gutter direction="top" size="xs">
          <Text>
            <Text color="coral">*</Text> {label}
          </Text>
        </Gutter>
      </Col>
      <Col span={16}>
        <Form.Item
          name={name}
          rules={[{ required: true, message: 'Please insert a value' }]}
        >
          <CurrencyInput
            max={999}
            prefix={icon}
            onBlur={() => onBlur?.(name)}
          />
        </Form.Item>
      </Col>
    </>
  );
}
